import React from 'react';
import { Box, Skeleton, Grid } from '@mui/material';

const PageSkeletonPayouts = () => {
  const isMobile = window.innerWidth < 900;

  return (
    <Box sx={{ width: '100%', marginTop: '20px' }}>
      <Grid container spacing={2}>
        <Grid item xs={12} md={5.9} lg={5.9}>
          <Box sx={{ 
            p: 2,
            border: '1px solid #E4EBF6', 
            borderRadius: '8px',
            bgcolor: 'white'
          }}>
            <Skeleton variant="text" width="40%" height={24} sx={{ mb: 1, bgcolor: '#E6EDF9' }} />
            <Skeleton variant="text" width="60%" height={32} sx={{ bgcolor: '#E6EDF9' }} />
          </Box>
        </Grid>

        <Grid item xs={12} md={5.9} lg={5.9}>
          <Box sx={{
            p: 2,
            border: '1px solid #E4EBF6',
            borderRadius: '8px', 
            bgcolor: 'white'
          }}>
            <Skeleton variant="text" width="40%" height={24} sx={{ mb: 1, bgcolor: '#E6EDF9' }} />
            <Skeleton variant="text" width="60%" height={32} sx={{ bgcolor: '#E6EDF9' }} />
          </Box>
        </Grid>

        {!isMobile && (
          <>
            <Grid item xs={12} md={12} lg={5.9}>
              <Box sx={{
                p: 2,
                border: '1px solid #E4EBF6',
                borderRadius: '8px',
                bgcolor: 'white'
              }}>
                <Skeleton variant="text" width="40%" height={24} sx={{ mb: 1, bgcolor: '#E6EDF9' }} />
                <Skeleton variant="text" width="70%" height={20} sx={{ mb: 2, bgcolor: '#E6EDF9' }} />
                <Box sx={{ display: 'flex', gap: 2, mb: 1 }}>
                  <Skeleton variant="rectangular" width={120} height={38} sx={{ bgcolor: '#E6EDF9' }} />
                  <Skeleton variant="rectangular" width={130} height={38} sx={{ bgcolor: '#E6EDF9' }} />
                </Box>
              </Box>
            </Grid>

            <Grid item xs={12} md={12} lg={5.9}>
              <Box sx={{
                p: 2,
                border: '1px solid #E4EBF6',
                borderRadius: '8px',
                bgcolor: 'white'
              }}>
                <Skeleton variant="text" width="40%" height={24} sx={{ mb: 1, bgcolor: '#E6EDF9' }} />
                <Skeleton variant="text" width="70%" height={20} sx={{ mb: 2, bgcolor: '#E6EDF9' }} />
                <Box sx={{ display: 'flex', gap: 2 }}>
                  <Skeleton variant="rectangular" width={120} height={38} sx={{ bgcolor: '#E6EDF9' }} />
                  <Skeleton variant="rectangular" width={130} height={38} sx={{ bgcolor: '#E6EDF9' }} />
                </Box>
              </Box>
            </Grid>

            <Grid item xs={12}>
              <Box sx={{
                p: 2,
                border: '1px solid #E4EBF6',
                borderRadius: '8px',
                bgcolor: 'white'
              }}>
                <Skeleton variant="rectangular" height={200} sx={{ bgcolor: '#E6EDF9' }} />
              </Box>
            </Grid>
          </>
        )}

      </Grid>
    </Box>
  );
};

export default PageSkeletonPayouts;
